export type GalleryCategoryId =
  | 'hochzeit_events'
  | 'firmen_events'
  | 'fest_scheune'
  | 'innenhof'
  | 'landhaus'
  | 'weinstube'
  | 'garten'

export interface GalleryImage {
  id: string
  src: string
  category: string
  title: string
}

function buildImages(
  categoryId: GalleryCategoryId,
  label: string,
  folder: string,
  fileNames: string[]
): GalleryImage[] {
  return fileNames.map((file) => {
    const src = `/assets/galerie/${folder}/${file}`
    const title = file.replace(/\.[^/.]+$/, '').replace(/_/g, ' ')
    return {
      id: `${categoryId}-${file}`,
      src,
      category: label,
      title,
    }
  })
}

// Firmen-Events
const firmenEventsFiles: string[] = [
  '2025_03_29HückelsMayParty-15.JPG',
  '2025_03_29HückelsMayParty-18.JPG',
  'HK_1008.JPG',
  'HK_1071.JPG',
  'HK_1091.JPG',
  'HK_1093.JPG',
  'HK_1106.JPG',
  'HK_1120.JPG',
  'HK_92.JPG',
  'HK_929.JPG',
  'HK_956 Kopie.JPG',
  'HK_956.JPG',
  'HK_968.JPG',
  'LL_1035.JPG',
  'LL_1075.JPG',
  'LL_1157.JPG',
  'LL_1224 Kopie.JPG',
  'LL_1245.JPG',
  'LL_1265.JPG',
  'LL_1271.JPG',
  'LL_1301.JPG',
  'LL_1302.JPG',
  'LL_1388.JPG',
  'LL_1394.JPG',
  'LL_1528.JPG',
  'LL_1535.JPG',
  'LL_1662.JPG',
  'LL_1699.JPG',
  'LL_1806.JPG',
  'LL_1813.JPG',
  'LL_1855.JPG',
  'LL_527.JPG',
  'LL_749.JPG',
  'LL_982.JPG',
]

// Raum: Fest-Scheune
const festScheuneFiles: string[] = [
  '20161202_165942.JPG',
  '20161202_170209.JPG',
  '20161202_170222.JPG',
  '20161202_191413.JPG',
  '20161202_191446.JPG',
  '20161202_193051.JPG',
  '20181120_180234.JPG',
  'DSCF0511.JPG',
  'event-location_hueckels-may_tischdekoration-01.JPG',
  'event-location_hueckels-may_tischdekoration-05.JPG',
  'event-location_hueckels-may_tischdekoration-06.JPG',
  'event-location_party-raum_scheune_0626.JPG',
  'event-location_party-raum_scheune_20181120_180234.JPG',
  'event-location_party-raum_scheune_20181120_180255.JPG',
  'event-location_party-raum_scheune_20190615_171040.JPG',
  'event-location_party-raum_scheune_20190615_171141.JPG',
  'event-location_party-raum_scheune_hochzeit_bearbeitet.JPG',
  'event-location_party-raum_scheune_hochzeitsfotos-krefeld.JPG',
  'Hochzeit_1.JPG',
  'Hochzeit_10 Kopie.JPG',
  'Hochzeit_11 Kopie.JPG',
  'Hochzeit_12 Kopie.JPG',
  'Hochzeit_13 Kopie.JPG',
  'Hochzeit_14 Kopie.JPG',
  'Hochzeit_15 Kopie.JPG',
  'Hochzeit_16 Kopie.JPG',
  'Hochzeit_2.JPG',
  'Hochzeit_3.JPG',
  'Hochzeit_4.JPG',
  'Hochzeit_5.JPG',
  'Hochzeit_6.JPG',
  'Hochzeit_7.JPG',
  'Hochzeit_9 Kopie.JPG',
  'Hochzeit_9.JPG',
  'IMG_2546 Kopie.JPG',
  'IMG_2560.JPG',
  'IMG_2735.JPG',
  'IMG_2739.JPG',
  'IMG_2746.JPG',
  'IMG_2755.JPG',
  'IMG_2757.JPG',
  'IMG_4713_NEW.JPG',
]

// Raum: Garten
const gartenFiles: string[] = [
  'DSCF3356.jpg',
  'DSCF3372 2.jpg',
  'HK_15.jpg',
  'HK_33.jpg',
  'HK_37.jpg',
  'HK_389.JPG',
  'HK_445.JPG',
  'HK_709.JPG',
  'HK_739.JPG',
  'HK_745.JPG',
  'HK_834.JPG',
  'IMG_2532.JPG',
  'IMG_4699.JPG',
  'LL_160.JPG',
  'LL_164.JPG',
  'LL_28.JPG',
  'LL_6.JPG',
  'LL_93.JPG',
]

// Raum: Innenhof
const innenhofFiles: string[] = [
  '20161202_165914.JPG',
  '20161202_184250~01.JPG',
  '20181120_180026.JPG',
  'event-location_innenhof_freie-trauung.JPG',
  'event-location_party-raum_scheune_terrasse_1500.JPG',
  'event-location_terrasse_grillstation_spanferkel.JPG',
  'event-location_terrasse_grillstation.JPG',
  'HK_136.JPG',
  'HK_184.JPG',
  'HK_229.JPG',
  'HK_253.JPG',
  'HK_260 Kopie 2.JPG',
  'HK_269.JPG',
  'HK_277.JPG',
  'HK_324.JPG',
  'HK_367.JPG',
  'HK_447.JPG',
  'HK_514.JPG',
  'HK_551.JPG',
  'HK_609.JPG',
  'HK_657.JPG',
  'HK_766.JPG',
  'HK_798.JPG',
  'IMG-20180831-WA0001~01.JPG',
  'LL_224.JPG',
  'LL_234.JPG',
  'LL_265.JPG',
  'LL_361.JPG',
  'LL_404.JPG',
  'LL_412.JPG',
  'LL_494.JPG',
]

// Raum: Landhaus
const landhausFiles: string[] = [
  'DSC01336 2.jpg',
  'DSC01337 2.jpg',
  'DSC01340 2.jpg',
  'DSC01346 2 Kopie.jpg',
  'DSC01359 2.jpg',
  'DSC01367 2.jpg',
  'DSC01369 2.jpg',
  'DSC01370 2.jpg',
  'DSC01374 2.jpg',
  'DSC01375 2.jpg',
  'DSC01378 2.jpg',
  'DSC01381 2.jpg',
  'DSC01382 2.jpg',
  'DSC01400 2.jpg',
  'DSC01402 2.jpg',
]

// Raum: Weinstube
const weinstubeFiles: string[] = [
  'DSC01386 2.JPG',
  'DSC01389 2.JPG',
  'DSC01392 2 Kopie.JPG',
]

export const galleryByCategory: Record<GalleryCategoryId, GalleryImage[]> = {
  // Hochzeiten: dieselben Bilder wie Fest-Scheune (Hochzeitsfotos aus der Scheune)
  hochzeit_events: buildImages('hochzeit_events', 'Hochzeiten', 'raum/fest_scheune', festScheuneFiles),
  firmen_events: buildImages('firmen_events', 'Firmenfeiern', 'firmen_events', firmenEventsFiles),
  fest_scheune: buildImages('fest_scheune', 'Fest-Scheune', 'raum/fest_scheune', festScheuneFiles),
  innenhof: buildImages('innenhof', 'Innenhof', 'raum/innenhof', innenhofFiles),
  landhaus: buildImages('landhaus', 'Landhaus', 'raum/landhaus', landhausFiles),
  weinstube: buildImages('weinstube', 'Weinstube', 'raum/weinstube', weinstubeFiles),
  garten: buildImages('garten', 'Garten', 'raum/garten', gartenFiles),
}

export type GalleryFilterId =
  | 'all'
  | 'hochzeit'
  | 'firmen'
  | 'fest_scheune'
  | 'innenhof'
  | 'landhaus'
  | 'weinstube'
  | 'garten'

// Reihenfolge „Alle“: zuerst Fest-Scheune (Raum/Atmosphäre), dann Räume, Firmenfeiern zum Schluss (weniger partylastig)
const ALL_CATEGORY_ORDER: GalleryCategoryId[] = [
  'fest_scheune',
  'innenhof',
  'landhaus',
  'weinstube',
  'garten',
  'firmen_events',
]

/**
 * Einfacher Hash für deterministische "Zufälligkeit"
 */
function simpleHash(str: string): number {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hash = ((hash << 5) - hash) + char
    hash = hash & hash // Convert to 32bit integer
  }
  return Math.abs(hash)
}

/**
 * Deterministischer Wert zwischen 0 und 1 basierend auf Seed
 */
function deterministicValue(seed: string): number {
  return (simpleHash(seed) % 1000) / 1000
}

/**
 * Erstellt einen wilden Mix aus allen Kategorien
 * Verwendet die Reihenfolge aus dem Dashboard (wichtige Bilder oben, unwichtige unten)
 * Die Bilder werden abwechselnd aus verschiedenen Kategorien genommen,
 * aber nicht nach einem festen Schema, um einen natürlichen Mix zu erzeugen
 */
function createWildMix(imagesByCategory: Map<GalleryCategoryId, GalleryImage[]>): GalleryImage[] {
  const result: GalleryImage[] = []
  
  // Teile Bilder jeder Kategorie: erste 50 Bilder nach oben, Rest nach unten
  // Die Reihenfolge innerhalb jeder Kategorie kommt bereits aus dem Dashboard!
  const goodByCategory = new Map<GalleryCategoryId, GalleryImage[]>()
  const otherByCategory = new Map<GalleryCategoryId, GalleryImage[]>()
  
  imagesByCategory.forEach((images, category) => {
    if (images.length === 0) return
    
    // Die ersten 50 Bilder kommen nach oben, der Rest nach unten
    // Die Reihenfolge ist bereits die aus dem Dashboard gespeicherte!
    const splitIndex = Math.min(50, images.length)
    goodByCategory.set(category, images.slice(0, splitIndex)) // Erste 50 = nach oben (wichtig)
    otherByCategory.set(category, images.slice(splitIndex)) // Rest = nach unten (unwichtig)
  })
  
  // Erstelle Queues für gute und schlechtere Bilder getrennt
  const goodQueues = Array.from(goodByCategory.entries())
    .filter(([_, imgs]) => imgs.length > 0)
    .map(([cat, imgs]) => ({
      category: cat,
      images: imgs,
      index: 0
    }))
  
  const otherQueues = Array.from(otherByCategory.entries())
    .filter(([_, imgs]) => imgs.length > 0)
    .map(([cat, imgs]) => ({
      category: cat,
      images: imgs,
      index: 0
    }))
  
  // Verwende die Reihenfolge aus ALL_CATEGORY_ORDER für die Kategorien
  // Das gibt uns eine konsistente Reihenfolge der Kategorien
  const categoryOrder = ALL_CATEGORY_ORDER
  
  // Sortiere Queues nach ALL_CATEGORY_ORDER
  goodQueues.sort((a, b) => {
    const indexA = categoryOrder.indexOf(a.category)
    const indexB = categoryOrder.indexOf(b.category)
    return indexA - indexB
  })
  
  otherQueues.sort((a, b) => {
    const indexA = categoryOrder.indexOf(a.category)
    const indexB = categoryOrder.indexOf(b.category)
    return indexA - indexB
  })
  
  // Zuerst: Mix aus guten Bildern (oben) - wichtige Bilder aus allen Kategorien
  let round = 0
  while (goodQueues.some(q => q.index < q.images.length)) {
    // In jeder Runde: nimm 1-2 Bilder pro Kategorie (variabel für wilderen Mix)
    goodQueues.forEach((queue, queueIdx) => {
      if (queue.index < queue.images.length) {
        // Deterministische Entscheidung: 30% Chance für 2 Bilder basierend auf Position
        const seed = `good_${queue.category}_${queue.index}_${round}`
        const shouldTakeTwo = deterministicValue(seed) < 0.3 && queue.index + 1 < queue.images.length
        const takeCount = shouldTakeTwo ? 2 : 1
        const toTake = Math.min(takeCount, queue.images.length - queue.index)
        
        for (let i = 0; i < toTake; i++) {
          // Die Reihenfolge innerhalb der Kategorie ist bereits die aus dem Dashboard!
          result.push(queue.images[queue.index])
          queue.index++
        }
      }
    })
    
    // Mische die Reihenfolge der Kategorien für nächste Runde leicht (nicht zu oft)
    if (round % 3 === 0 && goodQueues.length > 1) {
      // Tausche benachbarte Kategorien deterministisch
      for (let i = 0; i < goodQueues.length - 1; i++) {
        const seed = `swap_good_${i}_${round}`
        if (deterministicValue(seed) < 0.35) {
          ;[goodQueues[i], goodQueues[i + 1]] = [goodQueues[i + 1], goodQueues[i]]
        }
      }
    }
    
    round++
    
    // Entferne leere Queues
    for (let i = goodQueues.length - 1; i >= 0; i--) {
      if (goodQueues[i].index >= goodQueues[i].images.length) {
        goodQueues.splice(i, 1)
      }
    }
    
    if (goodQueues.length === 0) break
  }
  
  // Dann: Mix aus anderen Bildern (unten) - unwichtige Bilder aus allen Kategorien
  round = 0
  while (otherQueues.some(q => q.index < q.images.length)) {
    // In jeder Runde: nimm 1-2 Bilder pro Kategorie (variabel)
    otherQueues.forEach((queue, queueIdx) => {
      if (queue.index < queue.images.length) {
        const seed = `other_${queue.category}_${queue.index}_${round}`
        const shouldTakeTwo = deterministicValue(seed) < 0.3 && queue.index + 1 < queue.images.length
        const takeCount = shouldTakeTwo ? 2 : 1
        const toTake = Math.min(takeCount, queue.images.length - queue.index)
        
        for (let i = 0; i < toTake; i++) {
          // Die Reihenfolge innerhalb der Kategorie ist bereits die aus dem Dashboard!
          result.push(queue.images[queue.index])
          queue.index++
        }
      }
    })
    
    // Mische die Reihenfolge der Kategorien für nächste Runde leicht
    if (round % 3 === 0 && otherQueues.length > 1) {
      for (let i = 0; i < otherQueues.length - 1; i++) {
        const seed = `swap_other_${i}_${round}`
        if (deterministicValue(seed) < 0.35) {
          ;[otherQueues[i], otherQueues[i + 1]] = [otherQueues[i + 1], otherQueues[i]]
        }
      }
    }
    
    round++
    
    // Entferne leere Queues
    for (let i = otherQueues.length - 1; i >= 0; i--) {
      if (otherQueues[i].index >= otherQueues[i].images.length) {
        otherQueues.splice(i, 1)
      }
    }
    
    if (otherQueues.length === 0) break
  }
  
  return result
}

/**
 * Verschiebt die ersten N Bilder einer Kategorie nach oben (Rest nach unten)
 */
function moveFirstImagesUp(images: GalleryImage[], count: number): GalleryImage[] {
  if (images.length <= count) {
    return images
  }
  
  const firstImages = images.slice(0, count)
  const restImages = images.slice(count)
  
  // Erste Bilder zuerst (oben), dann Rest (unten)
  return [...firstImages, ...restImages]
}

// Statische Bilder aus galerie_neu
// Struktur: assets/galerie_neu/events_galerie/... und assets/galerie_neu/raum_galerie/...

// Bilder aus galerie_neu - Hochzeiten
const galerieNeuHochzeitFiles: string[] = [
  'event-location_hueckels-may_tischdekoration-01.JPG',
  'event-location_hueckels-may_tischdekoration-05.JPG',
  'event-location_hueckels-may_tischdekoration-06.JPG',
  'event-location_innenhof_freie-trauung.JPG',
  'event-location_party-raum_scheune_hochzeitsfotos-krefeld.JPG',
  'event-location_party-raum_scheune_hochzeit_bearbeitet.JPG',
  'Hochzeit_1.JPG',
  'Hochzeit_11 Kopie.JPG',
  'Hochzeit_12 Kopie.JPG',
  'Hochzeit_13 Kopie.JPG',
  'Hochzeit_14 Kopie.JPG',
  'Hochzeit_15 Kopie.JPG',
  'Hochzeit_2.JPG',
  'Hochzeit_3.JPG',
  'Hochzeit_4.JPG',
  'Hochzeit_5.JPG',
  'Hochzeit_7.JPG',
  'Hochzeit_9.JPG',
  'IMG_2546 Kopie.JPG',
  'IMG_2735.JPG',
  'IMG_2739.JPG',
  'IMG_2746.JPG',
  'IMG_2755.JPG',
  'IMG_2757.JPG',
  'IMG_4713_NEW.JPG',
]

// Bilder aus galerie_neu - Firmenfeiern
const galerieNeuFirmenFiles: string[] = [
  '20181120_180026.JPG',
  'HK_253.JPG',
  'HK_260 Kopie 2.JPG',
  'HK_324.JPG',
  'HK_367.JPG',
  'HK_514.JPG',
  'HK_709.JPG',
  'IMG_4699.JPG',
  'LL_234.JPG',
  'LL_361.JPG',
]

// Bilder aus galerie_neu - Fest-Scheune
const galerieNeuFestScheuneFiles: string[] = [
  'event-location_party-raum_scheune_hochzeitsfotos-krefeld.JPG',
  'event-location_party-raum_scheune_hochzeit_bearbeitet.JPG',
  'Hochzeit_16 Kopie.JPG',
  'Hochzeit_3.JPG',
  'Hochzeit_4.JPG',
  'Hochzeit_6.JPG',
  'IMG_4713_NEW.JPG',
]

// Bilder aus galerie_neu - Innenhof
const galerieNeuInnenhofFiles: string[] = [
  '20181120_180026.JPG',
  'event-location_innenhof_freie-trauung.JPG',
  'event-location_party-raum_scheune_terrasse_1500.JPG',
  'event-location_terrasse_grillstation.JPG',
  'event-location_terrasse_grillstation_spanferkel.JPG',
  'HK_136.JPG',
  'HK_184.JPG',
  'HK_229.JPG',
  'HK_253.JPG',
  'HK_260 Kopie 2.JPG',
  'HK_269.JPG',
  'HK_277.JPG',
  'HK_324.JPG',
  'HK_367.JPG',
  'HK_447.JPG',
  'HK_514.JPG',
  'HK_551.JPG',
  'HK_609.JPG',
  'HK_657.JPG',
  'HK_766.JPG',
  'HK_798.JPG',
  'IMG-20180831-WA0001~01.JPG',
  'LL_224.JPG',
  'LL_234.JPG',
  'LL_265.JPG',
  'LL_361.JPG',
  'LL_404.JPG',
  'LL_412.JPG',
  'LL_494.JPG',
]

// Bilder aus galerie_neu - Landhaus
const galerieNeuLandhausFiles: string[] = [
  'DSC01336 2.jpg',
  'DSC01340 2.jpg',
  'DSC01359 2.jpg',
  'DSC01367 2.jpg',
  'DSC01369 2.jpg',
  'DSC01370 2.jpg',
  'DSC01374 2.jpg',
  'DSC01375 2.jpg',
  'DSC01378 2.jpg',
  'DSC01381 2.jpg',
  'DSC01382 2.jpg',
  'DSC01400 2.jpg',
]

// Bilder aus galerie_neu - Weinstube
const galerieNeuWeinstubeFiles: string[] = [
  // Weinstube Bilder aus weinstube_galerie oder private_galerie
  'DSC01386 2.JPG',
  'DSC01389 2.JPG',
  'DSC01392 2 Kopie.JPG',
]

// Bilder aus galerie_neu - Garten
const galerieNeuGartenFiles: string[] = [
  'DSCF3356.jpg',
  'DSCF3372 2.jpg',
  'HK_15.jpg',
  'HK_33.jpg',
  'HK_37.jpg',
  'HK_389.JPG',
  'HK_445.JPG',
  'HK_709.JPG',
  'HK_739.JPG',
  'HK_745.JPG',
  'HK_834.JPG',
  'IMG_2532.JPG',
  'IMG_4699.JPG',
  'LL_160.JPG',
  'LL_164.JPG',
  'LL_28.JPG',
  'LL_6.JPG',
  'LL_93.JPG',
]

// Alle Bilder aus galerie_neu (für "Alle"-Ansicht)
// Diese Funktion sammelt alle Bilder und entfernt Dopplungen
function getAllGalerieNeuImages(): GalleryImage[] {
  const allImages: GalleryImage[] = []
  const seenFileNames = new Set<string>()
  
  // Sammle alle Bilder aus allen Kategorien
  const categories: Array<{ files: string[], categoryId: GalleryCategoryId, label: string, folder: string }> = [
    { files: galerieNeuHochzeitFiles, categoryId: 'hochzeit_events', label: 'Hochzeiten', folder: 'galerie_neu/events_galerie/hochzeit_galerie' },
    { files: galerieNeuFirmenFiles, categoryId: 'firmen_events', label: 'Firmenfeiern', folder: 'galerie_neu/events_galerie/firmen_galerie' },
    { files: galerieNeuFestScheuneFiles, categoryId: 'fest_scheune', label: 'Fest-Scheune', folder: 'galerie_neu/raum_galerie/festscheune_galerie' },
    { files: galerieNeuInnenhofFiles, categoryId: 'innenhof', label: 'Innenhof', folder: 'galerie_neu/raum_galerie/innenhof_galerie' },
    { files: galerieNeuLandhausFiles, categoryId: 'landhaus', label: 'Landhaus', folder: 'galerie_neu/raum_galerie/landhaus_galerie' },
    { files: galerieNeuWeinstubeFiles, categoryId: 'weinstube', label: 'Weinstube', folder: 'galerie_neu/raum_galerie/weinstube_galerie' },
    { files: galerieNeuGartenFiles, categoryId: 'garten', label: 'Garten', folder: 'galerie_neu/raum_galerie/garten_galerie' },
  ]
  
  categories.forEach(({ files, categoryId, label, folder }) => {
    files.forEach(file => {
      const normalizedFileName = file.toLowerCase().replace(/\s+/g, '_')
      
      // Prüfe auf Dopplungen
      if (!seenFileNames.has(normalizedFileName)) {
        seenFileNames.add(normalizedFileName)
        allImages.push({
          id: `${categoryId}-${file}`,
          src: `/assets/${folder}/${file}`,
          category: label,
          title: file.replace(/\.[^/.]+$/, '').replace(/_/g, ' '),
        })
      }
    })
  })
  
  return allImages
}

// Gruppiere Bilder nach Kategorien
function groupGalerieNeuImagesByCategory(): Map<GalleryCategoryId, GalleryImage[]> {
  const categoryMap = new Map<GalleryCategoryId, GalleryImage[]>()
  
  const categories: Array<{ files: string[], categoryId: GalleryCategoryId, label: string, folder: string }> = [
    { files: galerieNeuHochzeitFiles, categoryId: 'hochzeit_events', label: 'Hochzeiten', folder: 'galerie_neu/events_galerie/hochzeit_galerie' },
    { files: galerieNeuFirmenFiles, categoryId: 'firmen_events', label: 'Firmenfeiern', folder: 'galerie_neu/events_galerie/firmen_galerie' },
    { files: galerieNeuFestScheuneFiles, categoryId: 'fest_scheune', label: 'Fest-Scheune', folder: 'galerie_neu/raum_galerie/festscheune_galerie' },
    { files: galerieNeuInnenhofFiles, categoryId: 'innenhof', label: 'Innenhof', folder: 'galerie_neu/raum_galerie/innenhof_galerie' },
    { files: galerieNeuLandhausFiles, categoryId: 'landhaus', label: 'Landhaus', folder: 'galerie_neu/raum_galerie/landhaus_galerie' },
    { files: galerieNeuWeinstubeFiles, categoryId: 'weinstube', label: 'Weinstube', folder: 'galerie_neu/raum_galerie/weinstube_galerie' },
    { files: galerieNeuGartenFiles, categoryId: 'garten', label: 'Garten', folder: 'galerie_neu/raum_galerie/garten_galerie' },
  ]
  
  categories.forEach(({ files, categoryId, label, folder }) => {
    const images = files.map(file => ({
      id: `${categoryId}-${file}`,
      src: `/assets/${folder}/${file}`,
      category: label,
      title: file.replace(/\.[^/.]+$/, '').replace(/_/g, ' '),
    }))
    
    if (images.length > 0) {
      categoryMap.set(categoryId, images)
    }
  })
  
  return categoryMap
}


// Hauptfunktion: Lade Bilder aus galerie_neu (statisch)
export function getImagesForFilter(filterId: GalleryFilterId): GalleryImage[] {
  // Verwende immer galerie_neu Bilder
  return getImagesForFilterFromGalerieNeu(filterId)
}

// Funktion: Lade Bilder aus galerie_neu (statisch)
function getImagesForFilterFromGalerieNeu(filterId: GalleryFilterId): GalleryImage[] {
  if (filterId === 'all') {
    // Alle Bilder aus galerie_neu durchmischen, OHNE Dopplungen (nur bei "Alle")
    const imagesByCategory = groupGalerieNeuImagesByCategory()
    
    // Sammle Bilder aus allen Kategorien
    const categoryImages = new Map<GalleryCategoryId, GalleryImage[]>()
    
    ALL_CATEGORY_ORDER.forEach(cat => {
      const images = imagesByCategory.get(cat) || []
      
      if (images.length > 0) {
        categoryImages.set(cat, images)
      }
    })
    
    // Erstelle wilden Mix ohne Dopplungen (nur für "Alle")
    return createWildMixWithoutDuplicates(categoryImages)
  }

  const map: Record<Exclude<GalleryFilterId, 'all'>, GalleryCategoryId> = {
    hochzeit: 'hochzeit_events',
    firmen: 'firmen_events',
    fest_scheune: 'fest_scheune',
    innenhof: 'innenhof',
    landhaus: 'landhaus',
    weinstube: 'weinstube',
    garten: 'garten',
  }

  const cat = map[filterId as Exclude<GalleryFilterId, 'all'>]
  if (!cat) {
    return []
  }
  
  const imagesByCategory = groupGalerieNeuImagesByCategory()
  let images = imagesByCategory.get(cat) || []
  
  // Bei "Hochzeiten": erste 13 Bilder nach oben (Rest nach unten)
  if (filterId === 'hochzeit') {
    images = moveFirstImagesUp(images, 13)
  }
  
  // Bei einzelnen Kategorien: KEINE Dopplungserkennung - alle Bilder anzeigen
  return images
}

// Fallback: Alte statische Funktion (wird nicht mehr verwendet, aber für Kompatibilität behalten)
function getImagesForFilterStatic(filterId: GalleryFilterId): GalleryImage[] {
  if (filterId === 'all') {
    const imagesByCategory = new Map<GalleryCategoryId, GalleryImage[]>()
    
    ALL_CATEGORY_ORDER.forEach(cat => {
      const images = galleryByCategory[cat] ?? []
      if (images.length > 0) {
        imagesByCategory.set(cat, images)
      }
    })
    
    return createWildMix(imagesByCategory)
  }

  const map: Record<Exclude<GalleryFilterId, 'all'>, GalleryCategoryId> = {
    hochzeit: 'hochzeit_events',
    firmen: 'firmen_events',
    fest_scheune: 'fest_scheune',
    innenhof: 'innenhof',
    landhaus: 'landhaus',
    weinstube: 'weinstube',
    garten: 'garten',
  }

  const cat = map[filterId as Exclude<GalleryFilterId, 'all'>]
  if (!cat) {
    return []
  }
  
  let images = galleryByCategory[cat] ?? []
  
  if (filterId === 'hochzeit') {
    images = moveFirstImagesUp(images, 13)
  }
  
  return images
}

// Erstelle wilden Mix ohne Dopplungen
function createWildMixWithoutDuplicates(
  imagesByCategory: Map<GalleryCategoryId, GalleryImage[]>
): GalleryImage[] {
  const result: GalleryImage[] = []
  const seenFileNames = new Set<string>()
  
  // Verwende die bestehende createWildMix Logik, aber filtere Dopplungen
  const mixedImages = createWildMix(imagesByCategory)
  
  // Entferne Dopplungen basierend auf Dateinamen
  for (const img of mixedImages) {
    const fileName = img.src.split('/').pop() || ''
    const normalizedFileName = fileName.toLowerCase().replace(/\s+/g, '_')
    
    if (!seenFileNames.has(normalizedFileName)) {
      seenFileNames.add(normalizedFileName)
      result.push(img)
    }
  }
  
  return result
}



